export const BASE_API_URL = "http://localhost:8080/api";
/*export const BASE_API_URL =
  "https://fixman-hr-node-deploy-db4ade5f8887.herokuapp.com/api";
*/
export const constants = {
  currency: "RSD",
};
